export default "uniform mat4 u_MVPMatrix;\nuniform mat4 u_ModelMatrix;\nuniform mat4 u_NormalMatrix;\n";
//# sourceMappingURL=project2.vertex.glsl.js.map


//////////////////
// WEBPACK FOOTER
// ./~/luma.gl/dist/esm/shadertools/src/modules/project2/project2.vertex.glsl.js
// module id = 1585
// module chunks = 0